import { Link } from "@tanstack/react-router";
import type { ReactNode } from "react";
import { SiteFooter } from "@/components/site-footer";

export function LegalPage({ title, children }: { title: string; children: ReactNode }) {
  return (
    <div className="min-h-screen bg-bg text-ink flex flex-col">
      <header className="border-b border-line bg-bg/80 backdrop-blur-md">
        <div className="mx-auto flex h-16 max-w-[1120px] items-center justify-between px-5">
          <Link to="/" className="flex items-center gap-2.5 text-lg font-semibold tracking-tight">
            <span className="inline-block h-[22px] w-[22px] rounded-md bg-accent" />
            DeckScore
          </Link>
          <Link to="/" className="text-[14.5px] font-medium text-muted-ink hover:text-ink">
            ← Back to home
          </Link>
        </div>
      </header>

      <main className="flex-1 px-5 py-12 md:py-16">
        <article className="mx-auto max-w-[800px]">
          <h1 className="mb-8 text-[clamp(30px,4.4vw,44px)] font-semibold leading-[1.1] tracking-tight">
            {title}
          </h1>
          <div className="legal-prose text-[16px] leading-[1.75] text-ink-secondary">
            {children}
          </div>
        </article>
      </main>

      <SiteFooter />
    </div>
  );
}
